// Rutas de la aplicacion centralizadas
// Usar ROUTES.X en lugar de strings hardcodeados

export const ROUTES = {
  ROOT: '/',
  LOGIN: '/login',
  REGISTER: '/register',
  VERIFY_EMAIL: '/verificar-email',
  HOME: '/home',
  EQUIPOS: '/equipos',
  ORDENES_TRABAJO: '/ordenes-trabajo',
  CATEGORIAS: '/categorias',
  TIPOS_DOCUMENTO: '/tipos-documento',
  UBICACIONES: '/ubicaciones',
  ASISTENCIA: '/asistencia',
  PLANTILLAS_MANTENIMIENTO: '/plantillas-mantenimiento',
  PROGRAMAS: '/programas',
  GESTION_USUARIOS: '/admin/usuarios',
  GESTION_ROLES: '/admin/roles',
  ASIGNACION_PERMISOS: '/admin/permisos',
  MI_GALERIA: '/mi-galeria',
  MIS_ORDENES_TRABAJO: '/mis-ordenes-trabajo',
  MIS_ORDENES_TRABAJO_DETALLE: '/mis-ordenes-trabajo/:id',
  MIS_ORDENES_TRABAJO_ACTIVIDAD: '/mis-ordenes-trabajo/:id/actividad/:actividadId',
  CALENDARIO_OT: '/calendario-ot',
  HALLAZGOS: '/hallazgos',
  MIS_HALLAZGOS: '/mis-hallazgos',
  ANALYTICS: '/analytics'
};

export default ROUTES;
